import { type RouteRecordRaw } from 'vue-router'

import { useInfosStore } from './infos.store'

export const InfosRouter: RouteRecordRaw[] = [
  {
    path: '/infosPratiques',
    component: async () => import('./Infos.vue'),
  },
  {
    path: '/infosPratiques/create',
    component: async () => import('./AddingInfos.vue'),
    async beforeEnter() {
      await useInfosStore.getState().loadInfo(undefined)
    },
  },
  {
    path: '/infosPratiques/:id',
    component: async () => import('./AddingInfos.vue'),
    async beforeEnter(to) {
      await useInfosStore.getState().loadInfo(to.params.id as string)
    },
  },
]
